export const UNIQUE = 'unique';
